import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: var(--color-white);
  width: 100%;
  padding: 2rem 0;

  @media (max-width: 48rem) {
    padding: 2rem 1rem;
  }
`;

export const Header = styled.div`
  padding: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0;
  text-align: center;

  h2 {
    text-transform: uppercase;
  }

  h3 {
    margin-top: 1rem;

    span {
      color: var(--brand-primary);
    }
  }
     @media (max-width: 48rem) {
     h2, h3 {
     font-size: 2.2rem;
     margin-bottom: 0;
     }
`;

export const CardsContainer = styled.div`
  display: flex;
  padding: 0 2rem;
  flex-wrap: wrap;
  justify-content: center;
  gap: 3rem;

  @media (max-width: 48rem) {
    padding: 0 1rem;
  }
`;

export const Card = styled.div`
  margin: 1rem;
  max-width: 30rem;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: start;
  line-height: 1.4;
  @media (max-width: 64rem) {
    margin: 0;
  }
`;

export const CardContent = styled.div`
  padding: 3rem;
  text-align: center;
  @media (max-width: 64rem) {
    padding: 1rem;
  }
  @media (max-width: 48rem) {
    padding: 0.5rem;
  }
`;

export const IconContainer = styled.div`
  font-size: 3em;
  padding: 2rem;
  @media (max-width: 48rem) {
    padding: 0;
    margin-bottom: 1rem;
  }
`;

export const Title = styled.div`
  font-size: 2rem;
  padding-bottom: 1rem;
  text-transform: capitalize;
  font-weight: 600;
`;

export const Description = styled.p`
  margin-bottom: 1.6rem;
`;
